import React, { useRef } from "react";
import { useModelFilterSelector } from "../../../../redux/store";
import { ModelFilterLabel, sortOrderLabelMap, useModelFilterLabel } from "../../../../utils/labels";
import * as PillStyles from "../../../../../../../common-deprecated/styles/v2/lexus/components/Pill";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import * as Styles from "./styles/SortFiltersStyles";
import * as FilterBarStyles from "./styles/StaticFilterBarStyles";
import * as PopupListStyles from "./styles/PopupListStyles";
import useSortFilters from "../../../../hooks/useSortFilters";

type SortFilterPropsType = {
    hasNavOffset?: boolean;
    isFixed?: boolean;
};

const SortFilters = (props: SortFilterPropsType): JSX.Element => {
    const { hasNavOffset, isFixed } = props;
    const sortOrder = useModelFilterSelector(({ modelResults }) => modelResults.sortOrder);
    const buttonLabel = useModelFilterLabel(sortOrderLabelMap[sortOrder]);

    const popupRef = useRef<HTMLDivElement>(null);
    const { showPopup, togglePopup, items } = useSortFilters(popupRef);

    return (
        <Styles.Wrapper ref={popupRef}>
            <Styles.Pill>
                <PillStyles.Wrapper hasIcon onClick={togglePopup}>
                    <IconWrapper size="xl" iconColor="platinumDark">
                        <Icon variant="sort" />
                    </IconWrapper>
                    <PillStyles.Text>{buttonLabel}</PillStyles.Text>
                </PillStyles.Wrapper>
            </Styles.Pill>
            <FilterBarStyles.Button type="button" onClick={togglePopup}>
                <FilterBarStyles.ButtonLabel>{buttonLabel}</FilterBarStyles.ButtonLabel>
                <FilterBarStyles.ButtonIcon>
                    <Icon variant="sort" />
                </FilterBarStyles.ButtonIcon>
            </FilterBarStyles.Button>

            {showPopup && (
                <Styles.Popup hasNavOffset={hasNavOffset} isFixed={isFixed}>
                    {items.map(({ id, labelKey, onClick }) => (
                        <PopupListStyles.ItemRow key={id}>
                            <PopupListStyles.Item>
                                <PopupListStyles.Button onClick={onClick}>
                                    <ModelFilterLabel label={labelKey} />
                                </PopupListStyles.Button>
                            </PopupListStyles.Item>
                        </PopupListStyles.ItemRow>
                    ))}
                </Styles.Popup>
            )}
        </Styles.Wrapper>
    );
};

export default SortFilters;
